var isMiniAli = typeof my !== "undefined" && !!my && typeof my.showToast === "function";
var isMiniWx = typeof wx !== "undefined" && !!wx && (typeof wx.login !== "undefined" || typeof wx.miniProgram !== "undefined");
export function reqIdleCallback(callback, timeout) {
  //小程序下支持requestIdleCallback，但没有window，不能通过window.requestIdleCallback判断
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(callback, {
      timeout: timeout || 1000
    });
  } else {
    setTimeout(callback, 0);
  }
}
export function isInWindmillByMY() {
  if (!isMiniAli || !isMiniWx) return false;

  try {
    var UA = "";

    try {
      UA = navigator ? navigator.userAgent || navigator.swuserAgent : "";
    } catch (e) {}

    if (!UA) {
      try {
        UA = clientInformation ? clientInformation.appVersion : "";
      } catch (e) {}
    }

    var isDD = false;

    try {
      isDD = !!dd;
    } catch (e) {}

    return isDD || /AliApp\(AP/.test(UA) || /AliApp\(DingTalk/.test(UA) || /micromessenger/.test(UA);
  } catch (e) {
    return false;
  }
} // 支付宝返回： WIFI / 4G / 3G / 2G / UNKNOWN / NOTREACHABLE / WWAN
// 微信返回：   wifi / 5g / 4g / 3g / 2g / unknown / none

var _formatOutput = function _formatOutput() {
  var ret = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var networkType = (ret.networkType || "").toUpperCase() || "UNKNOWN";
  var networkAvailable = true;

  switch (networkType) {
    case "WI-FI":
      networkType = "WIFI";
    // 继续执行下去

    case "WIFI":
    case "5G":
    case "4G":
    case "3G":
    case "2G":
    case "WWAN":
      networkAvailable = true;
      break;

    case "NOTREACHABLE":
    case "NONE":
      networkType = "NONE";
      networkAvailable = false;
      break;

    case "UNKNOWN":
    default:
      networkType = "UNKNOWN";
      networkAvailable = true;
      break;
  }

  return {
    networkType: networkType,
    networkAvailable: typeof ret.isConnected === 'boolean' ? ret.isConnected : networkAvailable // 有isConnected就以它为准

  };
}; // 获取网络信息


export function getNetworkType(_ref) {
  var successCb = _ref.success,
      failCb = _ref.fail;
  var handleFunc = isMiniAli ? my.getNetworkType : isMiniWx ? wx.getNetworkType : null;
  handleFunc && handleFunc({
    success: function success(res) {
      if (res && typeof res.networkType === "string") {
        successCb && successCb(_formatOutput(res));
      }
    },
    fail: function fail(error) {
      failCb && failCb(error);
    }
  });
} // 监听网络变化，这里要判断isConnected，
// isConnected: true
// networkType: "Wi-Fi"

export function onNetworkStatusChange(_ref2) {
  var successCb = _ref2.success;
  var handleFunc = isMiniAli ? my.onNetworkStatusChange : isMiniWx ? wx.onNetworkStatusChange : null;
  handleFunc && handleFunc(function (res) {
    if (res && typeof res.networkType === "string") {
      successCb && successCb(_formatOutput(res));
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker@1.0.34@@ali/aes-tracker/es/utils.js
// module id = null
// module chunks = 